import { PaletteOptions } from '@mui/material';

const darkBluePalette: PaletteOptions = {
  primary: {
    900: '#0B1846',
    800: '#161C6D',
    700: '#202194',
    600: '#2B25BB',
    500: '#4640C3',
    400: '#605CCC',
    300: '#605CCC',
    200: '#9592DD',
    100: '#B0ADE5',
    50: '#CAC9EE',
    main: '#2B25BB',
  },
  secondary: {
    25: '#FFFAE5',
    50: '#FFF6CA',
    100: '#FFF1B0',
    200: '#FFED95',
    300: '#FEE87B',
    400: '#FEE360',
    500: '#FEDF46',
    600: '#FEDA2B',
    700: '#BFA320',
    800: '#7F6D16',
    900: '#40370B',
    main: '#FEDA2B',
  },
  error: {
    25: '#FEF0F0',
    50: '#FEE2E2',
    100: '#FED4D4',
    200: '#FEC6C6',
    300: '#FDB2B2',
    400: '#FB8C8C',
    500: '#FA6565',
    600: '#F93F3F',
    700: '#8C1D18',
    800: '#601410',
    900: '#410E0B',
  },
  neutral: {
    25: '#EAEBEC',
    50: '#D4D8DA',
    100: '#BFC4C7',
    200: '#AAB0B4',
    300: '#959DA2',
    400: '#80898F',
    500: '#6A757C',
    600: '#55626A',
    700: '#404E57',
    800: '#2B3A44',
    900: '#152732',
    A100: '#FFFFFF1A',
  },
  info: {
    100: '#BEF0FF',
    300: '#92E5FF',
    400: '#7DE0FF',
    500: '#67DBFF',
    600: '#51D6FF',
    700: '#3DA5C7',
    800: '#2B748D',
    main: '#7DE0FF',
  },
  background: {
    default: '#2E3E48',
    paper: '2E3E48',
  },
  text: {
    primary: '#fff',
    secondary: '#bcd2d6',
    disabled: '#6c7986',
  },
  promoPage: {
    heading: '#FFFFFF',
    description: '#B0ADE5',
    duration: '#CAC9EE',
    cardBackground: '#161C6D',
    buttonBorder: '#0B1846',
    buttonBackground: '#202194',
    buttonBackgroundHover: '#2B25BB',
    separator: '#605CCC66',
  },
} as const;

export default darkBluePalette;
